import React from 'react'
import css from './style.scss'

const FormRule = () => <hr className={css.formRule} />

export default FormRule
